import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect, normalizeClass as _normalizeClass, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, vModelText as _vModelText } from "vue"

const _hoisted_1 = { class: "post-code-block" }
const _hoisted_2 = { class: "post-code-block__wrapper" }
const _hoisted_3 = { class: "post-code-block__form" }
const _hoisted_4 = { for: "selectedProduct" }
const _hoisted_5 = ["aria-label"]
const _hoisted_6 = ["value"]
const _hoisted_7 = ["value"]
const _hoisted_8 = {
  key: 0,
  class: "error-message"
}
const _hoisted_9 = { for: "postCode" }
const _hoisted_10 = ["placeholder", "aria-label", "disabled"]
const _hoisted_11 = {
  key: 1,
  class: "error-message"
}
const _hoisted_12 = ["disabled"]
const _hoisted_13 = { key: 0 }
const _hoisted_14 = {
  key: 2,
  class: "result-message"
}
const _hoisted_15 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h2", null, _toDisplayString(_ctx.$t("PostCodeCheck.Title")), 1),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("label", _hoisted_4, _toDisplayString(_ctx.$t("PostCodeCheck.Products")), 1),
        _withDirectives(_createElementVNode("select", {
          id: "selectedProduct",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedProduct) = $event)),
          class: _normalizeClass({ 'error': _ctx.displayProductError }),
          "aria-label": _ctx.$t("PostCodeCheck.Products"),
          onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.displayProductError = false))
        }, [
          _createElementVNode("option", {
            disabled: "",
            value: _ctx.emptyPostCodeProduct,
            selected: ""
          }, _toDisplayString(_ctx.$t("PostCodeCheck.ChooseProduct")), 9, _hoisted_6),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.postCodeProducts, (product, index) => {
            return (_openBlock(), _createElementBlock("option", {
              value: product,
              key: index
            }, _toDisplayString(product.name), 9, _hoisted_7))
          }), 128))
        ], 42, _hoisted_5), [
          [_vModelSelect, _ctx.selectedProduct]
        ]),
        (_ctx.displayProductError)
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString(_ctx.$t("PostCodeCheck.SelectProductError")), 1))
          : _createCommentVNode("", true),
        _createElementVNode("label", _hoisted_9, _toDisplayString(_ctx.$t("PostCodeCheck.Postcode")), 1),
        _withDirectives(_createElementVNode("input", {
          type: "text",
          inputmode: "numeric",
          id: "postCode",
          ref: "postCodeInput",
          placeholder: _ctx.$t("PostCodeCheck.PostCodePlaceholder"),
          "aria-label": _ctx.$t("MultiFormBlock.ZipCodePlaceholder"),
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.postCode) = $event)),
          disabled: _ctx.selectedProduct === null,
          pattern: "^(LV-\\d{4}|[0-9]{3}\\s?[0-9]{2})$",
          class: _normalizeClass({ 'error': _ctx.displayInvalidPostCodeError }),
          onChange: _cache[3] || (_cache[3] = () => _ctx.validatePostCode(true)),
          onInput: _cache[4] || (_cache[4] = () => _ctx.validatePostCode(false))
        }, null, 42, _hoisted_10), [
          [_vModelText, _ctx.postCode]
        ]),
        (_ctx.displayInvalidPostCodeError)
          ? (_openBlock(), _createElementBlock("div", _hoisted_11, _toDisplayString(_ctx.$t("PostCodeCheck.InvalidPostCode")), 1))
          : _createCommentVNode("", true),
        _createElementVNode("button", {
          class: _normalizeClass(["button--primary button--base check-button", {'button--loading': _ctx.isLoading}]),
          disabled: _ctx.isLoading,
          onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.isDeliveryPossible && _ctx.isDeliveryPossible(...args)))
        }, [
          (!_ctx.isLoading)
            ? (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString(_ctx.$t("PostCodeCheck.ButtonText")), 1))
            : _createCommentVNode("", true)
        ], 10, _hoisted_12),
        (_ctx.resultMessage !== '')
          ? (_openBlock(), _createElementBlock("p", _hoisted_14, _toDisplayString(_ctx.resultMessage), 1))
          : _createCommentVNode("", true)
      ])
    ]),
    (_ctx.richtext)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "rich-text-block message",
          innerHTML: _ctx.richtext
        }, null, 8, _hoisted_15))
      : _createCommentVNode("", true)
  ]))
}